import React from 'react';
import PropTypes from 'prop-types';

import { AccordionDetails as MUIAccordionDetails } from '@material-ui/core';

export const AccordionDetails = props => <MUIAccordionDetails {...props} />;

AccordionDetails.propTypes = {
  classes: PropTypes.object
};

export default AccordionDetails;
